import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { ClaimPhotoUploadService } from '../services/claim-photo-upload.service';
import {
  PhotoUploadActionTypes,
  PhotoUploadLoad,
  PhotoUploadLoadFail,
  PhotoUploadLoadSuccess
} from './photo-upload.actions';

@Injectable()
export class PhotoUploadEffects {
  loadPhotos$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType<PhotoUploadLoad>(PhotoUploadActionTypes.PhotoUploadLoad),
      map(action => action.payload),
      switchMap(claimNumber =>
        this.claimPhotoUploadService.getPhotoDocuments(claimNumber).pipe(
          map(response => new PhotoUploadLoadSuccess(response)),
          catchError(error => of(new PhotoUploadLoadFail(error)))
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private claimPhotoUploadService: ClaimPhotoUploadService
  ) {}
}
